module.exports = __webpack_public_path__ + "static/media/obesidade.50dd179b.png";